import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBranding } from '@/utils/branding';
import { CashbackBanner } from './CashbackBanner';

type DeviceType = 'mobile' | 'tablet';

const useDeviceType = (): DeviceType => {
  const [deviceType, setDeviceType] = useState<DeviceType>('mobile');

  useEffect(() => {
    const checkDeviceType = () => {
      const isTablet = window.innerWidth >= 768;
      setDeviceType(isTablet ? 'tablet' : 'mobile');
    };

    // Check on mount
    checkDeviceType();

    // Listen for resize events
    window.addEventListener('resize', checkDeviceType);

    return () => {
      window.removeEventListener('resize', checkDeviceType);
    };
  }, []);

  return deviceType;
};

export const CashbackBannerController = () => {
  const { t } = useTranslation();
  const deviceType = useDeviceType();
  const { showCashbackUI } = useBranding();
  const content =
    deviceType === 'mobile'
      ? t('cashbackBanner.cashbackBannerController.getCashbackWithKitopi')
      : t('cashbackBanner.cashbackBannerController.getCashbackInApp');

  if (!showCashbackUI) return null;

  return <CashbackBanner floating content={content} />;
};
